import { ReactElement, useEffect, useState } from "react";

import "./view-uploaded-customers.scss";
import BreadcrumbComponent from "../../components/breadcrumb-component/breadcrumb-component";
import { Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import CustomTable from "../../components/custom-table/custom-table";
import successImage from "../../assets/success.svg";
import dangerImage from "../../assets/danger.svg";
import skipImage from "../../assets/skip.svg";
import clsx from "clsx";
import { Link, useParams } from "react-router-dom";
import UploadCustomersService from "../upload-customers/upload-customers.service";
import LogsModal from "../../components/logs-modal/logs-modal";
import moment from "moment";
import { CREATE_BREADCRUMB } from "src/store/actions";
import { useDispatch } from "react-redux";

const ViewUploadCustomer: React.FC = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const uploadCustomersService = new UploadCustomersService();
  const [onboardingFileData, setOnboardingFileData] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [logsModalVisible, setLogsModalVisible] = useState(false);
  const [selectedLogs, setSelectedLogs] = useState<string>("");
  const [statusFilter, setStatusFilter] = useState<string>("");
  const [filteredUsers, setFilteredUsers] = useState<any[]>([]);

  useEffect(() => {
    dispatch({
      type: CREATE_BREADCRUMB,
      payload: {
        breadcrumb: [
          {
            text: `Customers list`,
            type: "link",
            link: "/home/customers-list",
          },
          {
            text: `Uploaded customers`,
            type: "link",
            link: "/customers/upload",
          },
        ],
      },
    });
  }, []);

  useEffect(() => {
    fetchOnboardingFileDataById();
  }, [id]);

  useEffect(() => {
    if (onboardingFileData?.users) {
      if (statusFilter) {
        const filtered = onboardingFileData.users.filter((user: any) => {
          switch (statusFilter) {
            case "success":
              return user.successAccounts > 0;
            case "failed":
              return user.failedAccounts > 0;
            case "skipped":
              return user.skippedAccounts > 0;
            default:
              return true;
          }
        });
        setFilteredUsers(filtered);
      } else {
        setFilteredUsers(onboardingFileData.users);
      }
    }
  }, [onboardingFileData, statusFilter]);

  const fetchOnboardingFileDataById = async () => {
    setLoading(true);
    try {
      const data = await uploadCustomersService.getOnboardingFileDataById(id);
      setOnboardingFileData(data);
    } catch (error) {
      console.error("Error fetching onboarding file data:", error);
    } finally {
      setLoading(false);
    }
  };

  const columns: ColumnsType<any> = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Full  name",
      dataIndex: "fullName",
      key: "fullName",
      fixed: "left",
      render: (text, record) => (
        <span>
          {record?.firstName} {record?.lastName}
        </span>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Account",
      dataIndex: "accounts",
      key: "accounts",
      render: (text) => <Link to="">{text}</Link>,
    },
    {
      title: "Mobile number",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
    },
    {
      title: "Success",
      dataIndex: "successAccounts",
      key: "successAccounts",
    },
    {
      title: "Skipped",
      dataIndex: "skippedAccounts",
      key: "skippedAccounts",
    },
    {
      title: "Failed",
      dataIndex: "failedAccounts",
      key: "failedAccounts",
    },
    {
      title: "Created at",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => (
        <span>{moment(text).format("MMM DD, YYYY HH:mm")}</span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, record) => {
        let status = "pending";
        let statusClass = "pending";
        
        if (record.failedAccounts > 0) {
          status = "failed";
          statusClass = "failed";
        } else if (record.skippedAccounts > 0) {
          status = "skipped";
          statusClass = "skipped";
        } else if (record.successAccounts > 0) {
          status = "success";
          statusClass = "success";
        }
        
        return <span className={clsx("status", statusClass)}>{status}</span>;
      },
    },
    {
      title: "Logs",
      dataIndex: "logs",
      key: "logs",
      render: (text, record) =>
        text ? (
          <button
            // className="view-logs-btn"
            onClick={() => {
              setSelectedLogs(text);
              setLogsModalVisible(true);
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z"
                stroke="#002F6C"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M14 2V8H20"
                stroke="#002F6C"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M16 13H8"
                stroke="#002F6C"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M16 17H8"
                stroke="#002F6C"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10 9H8"
                stroke="#002F6C"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        ) : (
          <span className="no-logs">No logs</span>
        ),
    },
  ];

  return (
    <section className="upload-customers-container flex column">
      <BreadcrumbComponent />

      <div className="upload-data flex justify-space-between wrap">
        <div className="element flex column w-48">
          <label>Status</label>
          <p>{onboardingFileData?.status}</p>
        </div>
        <div
          className="element flex flex-col w-48 cursor-pointer"
          onClick={() => {
            setStatusFilter("");
          }}
        >
          <label>Total records</label>
          <p>{onboardingFileData?.totalUsers}</p>
        </div>
        <div
          className={`element flex flex-col w-32 cursor-pointer ${
            statusFilter === "success" ? "active" : ""
          }`}
          onClick={() =>
            setStatusFilter(statusFilter === "success" ? "" : "success")
          }
        >
          <div className="flex align-center justify-space-between">
            <label>Success</label>
            <img src={successImage} alt="" />
          </div>
          <p>
            {onboardingFileData?.users?.reduce(
              (acc: number, user: any) => acc + user.successAccounts,
              0
            )}
          </p>
        </div>
        <div
          className={`element flex flex-col w-32 cursor-pointer ${
            statusFilter === "failed" ? "active" : ""
          }`}
          onClick={() =>
            setStatusFilter(statusFilter === "failed" ? "" : "failed")
          }
        >
          <div className="flex align-center justify-space-between">
            <label>Failed</label>
            <img src={dangerImage} alt="" />
          </div>
          <p>
            {onboardingFileData?.users?.reduce(
              (acc: number, user: any) => acc + user.failedAccounts,
              0
            )}
          </p>
        </div>
        <div
          className={`element flex flex-col w-32 cursor-pointer ${
            statusFilter === "skipped" ? "active" : ""
          }`}
          onClick={() =>
            setStatusFilter(statusFilter === "skipped" ? "" : "skipped")
          }
        >
          <div className="flex align-center justify-space-between">
            <label>Skipped</label>
            <img src={skipImage} alt="" />
          </div>
          <p>
            {onboardingFileData?.users?.reduce(
              (acc: number, user: any) => acc + user.skippedAccounts,
              0
            )}
          </p>
        </div>
      </div>

      <div className="users-table">
        <div className="title flex align-center justify-space-between">
          <div className="flex align-center gap-16">
            <p>File data</p>
            {statusFilter && (
              <div className="filter-info">
                <span className="filter-badge">
                  Filtered by:{" "}
                  {statusFilter.charAt(0).toUpperCase() + statusFilter.slice(1)}
                </span>
                <button
                  className="reset-filter-btn"
                  onClick={() => setStatusFilter("")}
                >
                  Reset Filter
                </button>
              </div>
            )}
          </div>
          {/* <div className="images flex align-center">
            <CustomSearch />
            <Tooltip placement="topLeft" title="Columns settings">
              <img src={"/images/grid.svg"} alt="grid" />
            </Tooltip>
            <Tooltip placement="topLeft" title="Export">
              <img src={"/images/export.svg"} alt="export-customers" />
            </Tooltip>
          </div> */}
        </div>
        <CustomTable
          columns={columns}
          data={filteredUsers}
          showPagination={false}
        />
      </div>

      <LogsModal
        isVisible={logsModalVisible}
        onClose={() => setLogsModalVisible(false)}
        logs={selectedLogs}
        title="Upload Logs"
      />
    </section>
  );
};

export default ViewUploadCustomer;
